import React, {useState} from 'react';
import useDidMountEffect from "../../../../utils/useDidMountEffect";
import apiUser from "../../../../apiUser";
import Icon from "../../../../componentsReusable/Icon";
import RawToolsModal from "./RawToolsModal";
import {useTecRmi} from "../../../../contexts/TecRmiContext";

const RawToolsIcon = props => {
  const { getApiPrimaryParams } = useTecRmi()
  const [modalOpen, setModalOpen] = useState(false)
  const [rawToolsData, setRawToolsData] = useState(null)

  useDidMountEffect(() => {
    apiUser.tecRmi.times.rawTools({
      ...getApiPrimaryParams(),
      korId: props.workPosition.KorId,
      itemMpId: props.workPosition.ItemMpId,
    })
      .then(res => {
        setRawToolsData(res.data?.RawTools ? res.data?.RawTools[0] : null)
      })
  })

  if(rawToolsData){
    return <React.Fragment>
      <Icon className="fas fa-tools cursor-pointer p-2" tooltip="Niezbędne narzędzia" onClick={() => setModalOpen(true)} />
      {modalOpen && <RawToolsModal rawToolsData={rawToolsData} onClose={() => setModalOpen(false)} />}
    </React.Fragment>;
  }

  return null
};

export default RawToolsIcon;